// extracted by mini-css-extract-plugin
export default {"uploadContainer":"FileUpload_uploadContainer__2Rco7","focused":"FileUpload_focused__quRuq","progressBar":"FileUpload_progressBar__Swshl","deleteIcon":"FileUpload_deleteIcon__oCTyR"};